import { render, staticRenderFns } from "./CustomerBar.vue?vue&type=template&id=297f92e1&scoped=true"
import script from "./CustomerBar.vue?vue&type=script&lang=js"
export * from "./CustomerBar.vue?vue&type=script&lang=js"
import style0 from "./CustomerBar.vue?vue&type=style&index=0&id=297f92e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f92e1",
  null
  
)

export default component.exports